"use client";

import { displayValue } from "@/components/OtherBetsDropdown";
import { trendClass } from "./USTrendUtils";

export default function USCorrectScoresSection({ title, correctScoresFull }) {
  const { home = [], draw = [], away = [] } = correctScoresFull || {};
  const allScores = [...home, ...draw, ...away];

  if (allScores.length === 0) return null;

  return (
    <div className="us-ods-detail-item us-odt-card us-ods-100">
      <div className="us-odstb-title us-odt-txt">
        <span>{title}</span>
        <span></span>
      </div>
      <div className="us-odstb-odds-list us-scores-grid">
        {home.map((item, i) => (
          <div key={`h${i}`}>
            <div className="us-title-odds">{item.label}</div>
            <div className="score-values">
              <div
                className={`us-odds us-odt-odds us-ods-100 us-odds--white ${trendClass(
                  item.trend,
                )}`}
              >
                {displayValue(item.value)}
              </div>
              {item.value2 !== undefined && (
                <div
                  className={`us-odds us-odt-odds us-ods-100 us-odds--white ${trendClass(item.trend2)}`}
                >
                  {displayValue(item.value2)}
                </div>
              )}
            </div>
          </div>
        ))}
        {draw.map((item, i) => (
          <div key={`d${i}`}>
            <div className="us-title-odds">{item.label}</div>
            <div className="score-values">
              <div
                className={`us-odds us-odt-odds us-ods-100 us-odds--white ${trendClass(
                  item.trend,
                )}`}
              >
                {displayValue(item.value)}
              </div>
            </div>
          </div>
        ))}
        {away.map((item, i) => (
          <div key={`a${i}`}>
            <div className="us-title-odds">{item.label}</div>
            <div className="score-values">
              <div
                className={`us-odds us-odt-odds us-ods-100 us-odds--white ${trendClass(
                  item.trend,
                )}`}
              >
                {displayValue(item.value)}
              </div>
              {item.value2 !== undefined && (
                <div
                  className={`us-odds us-odt-odds us-ods-100 us-odds--white ${trendClass(item.trend2)}`}
                >
                  {displayValue(item.value2)}
                </div>
              )}
            </div>
          </div>
        ))}
        <div>
          <div className="us-title-odds">AOS</div>
          <div className="score-values">
            <div className="us-odds us-odt-odds us-ods-100 us-odds--white">-</div>
          </div>
        </div>
      </div>
    </div>
  );
}
